module.exports = __webpack_public_path__ + "static/media/CT_2019_30450_pdf.494f1b53.pdf";